import apiRequestService from '@/commonProject/service/apiRequestService';

export default class UserRepository {
    /**
     * ユーザー情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getUserApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usr', requestBody, idToken);
        return result;
    }
    /**
     * ユーザー情報詳細取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getUserDetailApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/usrdtl', requestBody, idToken);
        return result;
    }
    
    /**
     * ユーザー情報更新API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async updateUserApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/usrdtl', requestBody, idToken);
        return result;
    }
    /**
     * ユーザーパスワード更新API(cognito周りの認識なので仮状態)
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
        async updateUserPasswordApi(API_URL, requestBody, idToken) {
            const result = await apiRequestService.requestServerPut(API_URL + '/usrdtl', requestBody, idToken);
            // const { requestServerPost } = accountRepository();
            // const result = await requestServerPost('api/usr', requestBody);
            return result;
        }
}
